import React from "react";

import SICheckbox from "Common/SICheckbox";

class SIFormCheckbox extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      disabled,
      id,
      name,
      label,
      meta: { touched, invalid },
      input: { value, onChange },
      ...rest
    } = this.props;
    return <SICheckbox id={id} name={name} label={label} checked={value} disabled={disabled} onChange={onChange} error={touched && invalid} {...rest} />;
  }
}

SIFormCheckbox.defaultProps = {
  disabled: false,
  options: {
    Yes: "Yes",
    No: "No",
  },
  input: {},
};
export default SIFormCheckbox;
